import React from 'react';

import useClasses from '../../../../hooks/useClasses';
import { MenuItemSubtree } from '../..';
import MenuMainSubmenuItem from './Item';

import './style.scss';

interface Props {
  entities: MenuItemSubtree;
  onNavigate: (isSupportItem?: boolean) => void;
}

const MenuMainSubmenu: React.FC<Props> = ({ entities, onNavigate }) => {
  const { buildClass } = useClasses('MenuMainSubmenu');

  return (
    <nav className={buildClass()}>
      <ul className={buildClass('list')}>
        {entities.map((entity) => (
          <MenuMainSubmenuItem entity={entity} onNavigate={onNavigate} />
        ))}
      </ul>
    </nav>
  );
};

export default MenuMainSubmenu;
